<template>
  <div class="opinionCard" @click="routeGo">
    <img :src="item.Head" id="summary-pic">
    <div id="content">
      <div class="summary-name">
        <img src="@/assets/chat.png" id="chat-icon">
        <div class="name-content">
          <p id="doc-name">{{item.Name}}</p>
          <p id="summary-date">{{item.AdminSetTime}}</p>
        </div>
        <img src="@/assets/fullline.svg" id="fullline">
        <div class="summary-title">
          <a>{{item.Title}}</a>
        </div>
      </div>
      <p id="summary-mes">{{item.View}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "opinionCard",
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    routeGo() {
      this.$router.push(`/academic/opinion/opnDetail?id=${encodeURIComponent(this.item.Id)}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.opinionCard {
  display: flex;
  flex-direction: row;
  margin: 20px 0;
  cursor: pointer;
  //max-height: 200px;
  //overflow: hidden;
}
#content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.summary-name {
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.summary-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  min-width: 0;
  flex: 1;
  &:hover {
    text-decoration: underline;
  }
  a {
    @include hideTextOverflow;
  }
}
.name-content {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  justify-content: center;
}
#summary-content {
  display: flex;
  width: 45%;
  margin-bottom: 16px;
}
#summary-pic {
  width: 198px;
  height: 200px;
  margin-right: 15px;
}
#summary-date {
  margin-top: 6px;
  color: #c5c5c7;
  font-size: 16px;
}
#summary-mes {
  background-color: rgba(255, 255, 255, 0);
  font-size: 16px;
  line-height: 32px;
  margin: 10px;
  flex-wrap: wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
#fullline {
  opacity: 0.2;
  margin-right: 15px;
  margin-left: 10px;
  transform: scale(0.8);
}
#chat-icon {
  margin-right: 10px;
}
#doc-name {
  font-size: 20px;
  text-align: center;
  white-space: nowrap;
  color: #333333;
}
</style>